import { createTextVNode as _createTextVNode, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode } from "vue";
/**
 * @author yili
 * @fileoverview 赛事说明-移动
 */
import _ from "lodash";
import { defineComponent, reactive, computed } from "vue";
// components
import SwiperBox from "@/components/m/common/swiperBox.vue";
import SelectBtn from "@/components/m/common/select-btns.vue";
// config
import { informationDateList, awardList, ywAwardList, zhAwardList, entryRuleList, raceRulesList, groupList, scPlanListM } from "@/config/information";
// assets
import scTitleUrl from "@/assets/img/m/sc-title.png";
const awardAllList = [awardList, zhAwardList, ywAwardList];
export default defineComponent({
  name: "RaceInfoM",
  props: {
    // 是否是被其它组件引入
    referType: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    // 组件状态
    const state = reactive({
      dateActive: 1,
      requireActive: 1,
      ruleActive: 1,
      informationDateShowlist: informationDateList[0].list,
      btnSelectActive: 1
    });
    const ruleList = computed(() => {
      return _.find(raceRulesList, item => state.ruleActive === item.id).list;
    });
    function dateActiveChange(id) {
      state.dateActive = id;
      informationDateList.forEach(item => {
        if (id === item.id) {
          state.informationDateShowlist = item.list;
        }
      });
    }
    function requireActiveChange(id) {
      state.requireActive = id;
    }
    function handleRuleActive(id) {
      state.ruleActive = id;
    }
    return () => {
      // 赛程安排 - 日程信息展示
      const itemDateInfo = _.map(state.informationDateShowlist, item => {
        return _createVNode("div", {
          "class": "item-box"
        }, [_createVNode("div", {
          "class": "item-t"
        }, [_createVNode("div", {
          "class": "name-box"
        }, [_createVNode("span", {
          "class": "name",
          "innerHTML": item.name
        }, null)]), _createVNode("img", {
          "class": "bg",
          "src": require(`@/assets/img/m/sc-item-bg.png`)
        }, null)]), _createVNode("div", {
          "class": "item-b"
        }, [_createVNode("div", {
          "class": "text"
        }, [_createVNode("span", {
          "innerHTML": item.date
        }, null), item.hour && _createVNode("span", null, [item.hour])])])]);
      });
      const divide = _.map(state.informationDateShowlist, () => {
        return _createVNode("div", {
          "class": "divide-item"
        }, [_createVNode("span", null, null), _createVNode("a", null, null), _createVNode("span", null, null)]);
      });
      const planItem = _.map(scPlanListM, item => {
        return _createVNode("img", {
          "class": "item",
          "src": require(`@/assets/img/${item.image}`)
        }, null);
      });
      // 赛程安排
      const informationDateBox = _createVNode("div", {
        "class": "sc-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": scTitleUrl
      }, null), _withDirectives(_createVNode("div", {
        "class": "btn-box"
      }, [_createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          dateActiveChange(1);
        },
        "src": require(`@/assets/img/m/sc-1${state.dateActive === 1 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          dateActiveChange(2);
        },
        "src": require(`@/assets/img/m/sc-2${state.dateActive === 2 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          dateActiveChange(3);
        },
        "src": require(`@/assets/img/m/sc-3${state.dateActive === 3 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          dateActiveChange(4);
        },
        "src": require(`@/assets/img/m/sc-4${state.dateActive === 4 ? "-act" : ""}.png`)
      }, null)]), [[_vShow, false]]), _withDirectives(_createVNode("div", {
        "class": "info-box"
      }, [_createVNode("div", {
        "class": "info-t"
      }, [itemDateInfo]), _createVNode("div", {
        "class": "divide-b"
      }, [_createVNode("span", {
        "class": "other"
      }, null), _createVNode("div", {
        "class": "inner"
      }, [divide, _createTextVNode(" ")]), _createVNode("span", {
        "class": "other"
      }, null)])]), [[_vShow, false]]), _createVNode("div", {
        "class": "plan-wrap"
      }, [planItem])]);

      // 赛程奖励
      const awardBox = _createVNode("div", {
        "class": "award-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": require(`@/assets/img/m/jl-title.png`)
      }, null), _createVNode("div", {
        "class": "operate-box"
      }, [_createVNode(SelectBtn, {
        "onClick": val => {
          state.btnSelectActive = val.value;
          awardAllList[state.btnSelectActive];
        },
        "dataValue": state.btnSelectActive,
        "options": groupList,
        "defaultOption": groupList[1]
      }, null)]), _createVNode(SwiperBox, {
        "swiperSetInfo": awardAllList[state.btnSelectActive - 1].three
      }, null), _createVNode(SwiperBox, {
        "swiperSetInfo": awardAllList[state.btnSelectActive - 1].other
      }, null)]);

      // 赛程规则-参赛要求
      // function buildContentItem(item, index) {
      //   return (
      //     <div key={index} class="content-item">
      //       <div
      //         class="sub-title"
      //         style={{
      //           background: `url(${require(`@/assets/img/pc/title-arrow.png`)}) no-repeat`,
      //           backgroundSize: `cover`,
      //         }}
      //       >
      //         <span>{item.subTitle}</span>
      //       </div>
      //       <div class="content-box" innerHTML={item.contentText}></div>
      //     </div>
      //   );
      // }
      // 赛程规则
      const ruleBox = _createVNode("div", {
        "class": "rule-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": require(`@/assets/img/m/rule-title.png`)
      }, null), _createVNode("div", {
        "class": "operate-box"
      }, [_createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          requireActiveChange(1);
        },
        "src": require(`@/assets/img/m/rule-btn1${state.requireActive === 1 ? "-act" : ""}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          requireActiveChange(2);
        },
        "src": require(`@/assets/img/m/rule-btn2${state.requireActive === 2 ? "-act" : ""}.png`)
      }, null)]), state.requireActive === 1 ? _createVNode("div", {
        "class": "entry-content"
      }, [_createVNode("img", {
        "class": "bg",
        "src": require(`@/assets/img/m/entry-bg.png`)
      }, null), _createVNode("div", {
        "class": "content-inner"
      }, [_.map(entryRuleList, (item, index) => {
        {/* return buildContentItem(item, index); */}
        return _createVNode("div", {
          "class": "entry-rule-item",
          "innerHTML": item.contentText,
          "key": index
        }, null);
      })])]) : _createVNode("div", {
        "class": "rule-content"
      }, [_createVNode("img", {
        "class": "bg",
        "src": require(`@/assets/img/m/rule-bg.png`)
      }, null), _createVNode("div", {
        "class": "content-inner"
      }, [_createVNode("div", {
        "class": "sub-btns"
      }, [_createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          handleRuleActive(1);
        },
        "src": require(`@/assets/img/m/r-1${state.ruleActive === 1 ? "-actbtn" : "-btn"}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          handleRuleActive(2);
        },
        "src": require(`@/assets/img/m/r-2${state.ruleActive === 2 ? "-actbtn" : "-btn"}.png`)
      }, null), _createVNode("img", {
        "class": "btn-img",
        "onClick": () => {
          handleRuleActive(3);
        },
        "src": require(`@/assets/img/m/r-3${state.ruleActive === 3 ? "-actbtn" : "-btn"}.png`)
      }, null)]), _.map(ruleList.value, (item, index) => {
        {/* return buildContentItem(item, index); */}
        return _createVNode("div", {
          "class": "entry-rule-item",
          "innerHTML": item.contentText,
          "key": index
        }, null);
      })])])]);
      return _createVNode("div", {
        "class": "m-information"
      }, [props.referType === "homepage" ? informationDateBox : "", props.referType === "homepage" ? "" : ruleBox, props.referType === "homepage" ? "" : awardBox]);
    };
  }
});